import { ActionStatusTypes } from "../../types/interfaces";
import {
  IBadgesListState,
  BadgesActions,
  BadgesActionsTypes,
} from "./badgesTypes";

const initialBadgesState: IBadgesListState = {
  selectedBadgeId: undefined,
  badgesData: undefined,
  loadBadgesDataStatus: ActionStatusTypes?.neutral,
  deleteBadgeStatus: ActionStatusTypes?.neutral,
  createBadgesStatus: ActionStatusTypes?.neutral,
  createBadgesResponse: undefined,
  error: "",
};

export function badgesReducer(
  state = initialBadgesState,
  action: BadgesActions
): IBadgesListState {
  switch (action.type) {
    case BadgesActionsTypes.SELECT_BADGE_ID:
      return {
        ...state,
        selectedBadgeId: action.payload.badgeId,
      };
    case BadgesActionsTypes.GET_BADGES_DATA:
      return {
        ...state,
        loadBadgesDataStatus: ActionStatusTypes?.loading,
        deleteBadgeStatus: ActionStatusTypes?.neutral,
        createBadgesStatus: ActionStatusTypes?.neutral,
      };
    case BadgesActionsTypes.GET_BADGES_DATA_SUCCESS:
      return {
        ...state,
        badgesData: { ...action.payload, total: action.payload?.total },
        loadBadgesDataStatus: ActionStatusTypes?.success,
      };
    case BadgesActionsTypes.GET_BADGES_DATA_FAILED:
      return {
        ...state,
        badgesData: undefined,
        loadBadgesDataStatus: ActionStatusTypes?.failed,
        error: action.payload.error,
      };
    case BadgesActionsTypes.DELETE_BADGE:
      return {
        ...state,
        deleteBadgeStatus: ActionStatusTypes?.loading,
      };
    case BadgesActionsTypes.DELETE_BADGE_SUCCESS:
      return {
        ...state,
        deleteBadgeStatus: ActionStatusTypes?.success,
      };
    case BadgesActionsTypes.DELETE_BADGE_FAILED:
      return {
        ...state,
        deleteBadgeStatus: ActionStatusTypes?.failed,
      };
    case BadgesActionsTypes.CREATE_BADGES:
      return {
        ...state,
        createBadgesStatus: ActionStatusTypes?.loading,
        createBadgesResponse: undefined,
      };
    case BadgesActionsTypes.CREATE_BADGES_SUCCESS:
      return {
        ...state,
        createBadgesResponse: action.payload.response,
        createBadgesStatus: ActionStatusTypes?.success,
      };
    case BadgesActionsTypes.CREATE_BADGES_FAILED:
      return {
        ...state,
        createBadgesResponse: undefined,
        createBadgesStatus: ActionStatusTypes?.failed,
      };
    case BadgesActionsTypes.CLEAN_CREATE_BADGES_RESPONSE:
      return {
        ...state,
        createBadgesResponse: undefined,
        createBadgesStatus: ActionStatusTypes?.neutral,
      };
    default:
      return state;
  }
}
